import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import withStyles from '@mui/styles/withStyles';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import withRouter from '../../../organisms/withRouter.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import PaperPart from '../../../atoms/PaperPart.js';
import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import {sysErr} from '../../../../common/commonGmn.js';
import {renderTextField} from '../../../atoms/CustomPart.js';
import {reduxForm, getFormValues} from 'redux-form';
import {
  Typography,
} from '@mui/material';

const styles = (theme) => ({
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    height: 'auto',
    idth: '95%',
    overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },

});

class CustomerInfo extends React.Component {
  constructor(props) {
    super(props);
    // 一覧Ref作成
    this.gridRef1 = React.createRef();
  }

  closeModal = () => {
    console.log('close');
    this.props.doCloseModal();
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    // let mdHistoryList = [];
    let headerData = {NWjigyosyo_code: '広島NWC',
      sectionNo: '10001',
      tell: '080-1111-2222',
      customerName: '田中　小学校',
      supplyPointNo: '1234567890123456789012',
      address: '広島市　XXXX町　XXXXX番号　XXXX丁目　101アパート',
      pole_number: 'NNNNNNN 012 H01 M02 H03',
      pole_name: '〇〇〇〇線(1234A12)0010001',
      keisyu_code: '定額電灯',
      hijika_category: '非自家用',
      chousa_industry: '寝たきり',
      chousa_reason: '調査理由の取消',
      zenkai_year: '2025',
      keiryou_kva: '',
      keiryou_kw: '100',
      aisenn_code: '単相　２線式　１００V',
      keiki_manage: 'スイッチオフ',
      tizyoko_kizyun: '3.5m',
      tizyoko_sokutei: '5.5m',
      keiki_1: '1234567890',
      keiki_2: '1234567890',
      keiki_3: '1234567890',
      keiki_4: '1234567890',
      bunsan_dengen: '有',
      dt_kyoyou: '有',
      dt_kyoyou_no: 'K00000001',
      torituke_code: '1',
      torituke_name: '〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇',
      service_menu: '電灯時間帯別',
      keyakuStatus: '契約中',
      customer_meno: 'メモ〇〇〇〇〇〇〇〇〇〇〇',
    };

    // データを画面に設定
    this.props.doSetInitValues(headerData);
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  // async componentDidUpdate() {
  //   try {
  //     this.getInitializeData();
  //     return;
  //   } catch (error) {
  //     sysErr(this.props);
  //   }
  // }

  /**
   * お客さま情報の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCustomerInfo() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="NWjigyosyo_code" item xs={12} sm={2}>
            <Field
              id="NWjigyosyo_code"
              name="NWjigyosyo_code"
              component={renderTextField}
              className="fields"
              fullWidth
              label="NW事業所"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="sectionNo" item xs={12} sm={2}>
            <Field
              id="sectionNo"
              name="sectionNo"
              component={renderTextField}
              className="fields"
              fullWidth
              label="ブロック番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="supplyPointNo" item xs={12} sm={4}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              component={renderTextField}
              className="fields"
              fullWidth
              label="供給地点特定番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="customerName" item xs={12} sm={4}>
            <Field
              id="customerName"
              name="customerName"
              component={renderTextField}
              className="fields"
              fullWidth
              label="お客さま名"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="tell" item xs={12} sm={2}>
            <Field
              id="tell"
              name="tell"
              component={renderTextField}
              className="fields"
              fullWidth
              label="電話番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>

          <Grid key="address" item xs={12} sm={6}>
            <Field
              id="address"
              name="address"
              component={renderTextField}
              className="fields"
              fullWidth
              label="住所"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="pole_number" item xs={12} sm={4}>
            <Field
              id="pole_number"
              name="pole_number"
              component={renderTextField}
              className="fields"
              fullWidth
              label="引込電柱番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >

          <Grid key="service_menu" item xs={12} sm={3}>
            <Field
              id="service_menu"
              name="service_menu"
              component={renderTextField}
              className="fields"
              fullWidth
              label="サービスメニュー"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keyakuStatus" item xs={12} sm={3}>
            <Field
              id="keyakuStatus"
              name="keyakuStatus"
              component={renderTextField}
              className="fields"
              fullWidth
              label="契約状況"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keisyu_code" item xs={12} sm={3}>
            <Field
              id="keisyu_code"
              name="keisyu_code"
              component={renderTextField}
              className="fields"
              fullWidth
              label="契種相当"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="hijika_category" item xs={12} sm={3}>
            <Field
              id="hijika_category"
              name="hijika_category"
              component={renderTextField}
              className="fields"
              fullWidth
              label="調査管理区分"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keiryou_kva" item xs={12} sm={2}>
            <Field
              id="keiryou_kva"
              name="keiryou_kva"
              component={renderTextField}
              className="fields"
              fullWidth
              label="契約容量（ＫＶＡ）"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keiryou_kw" item xs={12} sm={2}>
            <Field
              id="keiryou_kw"
              name="keiryou_kw"
              component={renderTextField}
              className="fields"
              fullWidth
              label="契約電力（ＫＷ）"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="aisenn_code" item xs={12} sm={3}>
            <Field
              id="aisenn_code"
              name="aisenn_code"
              component={renderTextField}
              className="fields"
              fullWidth
              label="相線電圧"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="zenkai_year" item xs={12} sm={2}>
            <Field
              id="zenkai_year"
              name="zenkai_year"
              component={renderTextField}
              className="fields"
              fullWidth
              label="前回調査年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="chousa_reason" item xs={12} sm={3}>
            <Field
              id="chousa_reason"
              name="chousa_reason"
              component={renderTextField}
              className="fields"
              fullWidth
              label="調査理由"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="chousa_industry" item xs={12} sm={3}>
            <Field
              id="chousa_industry"
              name="chousa_industry"
              component={renderTextField}
              className="fields"
              fullWidth
              label="調査業種"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keiki_manage" item xs={12} sm={3}>
            <Field
              id="keiki_manage"
              name="keiki_manage"
              component={renderTextField}
              className="fields"
              fullWidth
              label="計器管理"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="bunsan_dengen" item xs={12} sm={2}>
            <Field
              id="bunsan_dengen"
              name="bunsan_dengen"
              component={renderTextField}
              className="fields"
              fullWidth
              label="分散電源"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="tizyoko_kizyun" item xs={12} sm={2}>
            <Field
              id="tizyoko_kizyun"
              name="tizyoko_kizyun"
              component={renderTextField}
              className="fields"
              fullWidth
              label="地上高（基準）"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="tizyoko_sokutei" item xs={12} sm={2}>
            <Field
              id="tizyoko_sokutei"
              name="tizyoko_sokutei"
              component={renderTextField}
              className="fields"
              fullWidth
              label="地上高（測定値）"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>

        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keiki_1" item xs={12} sm={3}>
            <Field
              id="keiki_1"
              name="keiki_1"
              component={renderTextField}
              className="fields"
              fullWidth
              label="計器１"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keiki_2" item xs={12} sm={3}>
            <Field
              id="keiki_2"
              name="keiki_2"
              component={renderTextField}
              className="fields"
              fullWidth
              label="計器２"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keiki_3" item xs={12} sm={3}>
            <Field
              id="keiki_3"
              name="keiki_3"
              component={renderTextField}
              className="fields"
              fullWidth
              label="計器３"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keiki_4" item xs={12} sm={3}>
            <Field
              id="keiki_4"
              name="keiki_4"
              component={renderTextField}
              className="fields"
              fullWidth
              label="計器４"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="dt_kyoyou" item xs={12} sm={3}>
            <Field
              id="dt_kyoyou"
              name="dt_kyoyou"
              component={renderTextField}
              className="fields"
              fullWidth
              label="引込線共用"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="dt_kyoyou_no" item xs={12} sm={3}>
            <Field
              id="dt_kyoyou_no"
              name="dt_kyoyou_no"
              component={renderTextField}
              className="fields"
              fullWidth
              label="共用番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 負荷設備の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderSetubiInfo() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="torituke_code" item xs={12} sm={6}>
            <Field
              id="torituke_code"
              name="torituke_code"
              component={renderTextField}
              className="fields"
              fullWidth
              label="取付場所区分"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="torituke_name" item xs={12} sm={6}>
            <Field
              id="torituke_name"
              name="torituke_name"
              component={renderTextField}
              className="fields"
              fullWidth
              label="取付場所名"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };
  /**
   * 調査メモの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCustomerMeno() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="customer_meno" item xs={12} sm={12}>
            <Field
              id="customer_meno"
              name="customer_meno"
              component={renderTextField}
              className="fields"
              fullWidth
              label="お客さまメモ"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>

        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes, openState, handleClose} = this.props;

    return (
      <Modal
        open={openState}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>お客さま情報参照</Typography>
          <div style={{marginBottom: '10px'}} />
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>・基本情報</Typography>
          <div style={{marginBottom: '10px'}} />
          {this.renderCustomerInfo()}
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>・公衆街路灯</Typography>
          <div style={{marginBottom: '10px'}} />
          {this.renderSetubiInfo()}
          <div style={{marginBottom: '10px'}} />
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>・お客さまメモ</Typography>
          <div style={{marginBottom: '10px'}} />
          {this.renderCustomerMeno()}
          <div style={{marginBottom: '10px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="keyModalCloseBtn" item >
              <NegativeButton
                id="btnCloser"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={handleClose}
              >
                <span>閉じる</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  }
}

CustomerInfo.propTypes = {
  classes: PropTypes.object,
  modalInfo: PropTypes.object,
  content: PropTypes.object,
  doCloseModal: PropTypes.func,
  handleClose: PropTypes.func,
  handleExec: PropTypes.func,
  initialValues: PropTypes.func,
  openState: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  modalInfo: state.common.modalInfo,
  initialValues: state.common.setInitValues,
});

const mapDispatchToProps = {
  doCloseModal: commonOperations.doCloseModal,
  doSetInitValues: commonOperations.doSetInitValues,
};
const FORM_NAME = 'CustomerInfo';

CustomerInfo = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(CustomerInfo));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(withFormatMessage(withMediaQuery()(CustomerInfo)))),
);

